import { PreferencesService } from "./preferences-service";

let preferencesService = new PreferencesService();

export { preferencesService }